export class MultiSelectWithAutoTransform extends kendo.ui.MultiSelect {
    isUpdating = false;
    countUntilTransform = 3;

    constructor(element: Element, options?: kendo.ui.MultiSelectOptions) {
        super(element, MultiSelectWithAutoTransform.getOptions(options));
        this.bind("change", this.itemChangeClientSide);
        this.bind("dataBound", this.itemChangeClientSide);
        this.countUntilTransform = options.countUntilTransform;
    }

    static getOptions = (options: kendo.ui.MultiSelectOptions): kendo.ui.MultiSelectOptions => {
        const dataTextField = options.dataTextField !== undefined ? options.dataTextField : "data";
        const multipleTemplate = options.tagTemplate !== undefined
            ? options.tagTemplate
            : `#=${dataTextField}#`;
        const template = `#if(data.values){#<span class="multiSelectTooltip" data-tooltip="#= MultiSelectWithAutoTransform.createToolTip(data.dataItems,"${dataTextField}") #">#= data.values.length # ${TextResources.Views_ItemsSelected} </span>#}else{#${multipleTemplate}#}#`;
        options.tagTemplate = template;
        if (!options.noDataTemplate) {
            options.noDataTemplate = TextResources.Error_KeineEintraege;
        }
        return options;
    }

    static createToolTip = (values, options): string => {
        let tooltip = "";
        for (let i = 0; i < values.length; i++) {
            if (typeof values[i] === 'object') {
                if (options !== "data") {
                    tooltip += `${values[i][options]}, `;
                }
            } else {
                tooltip += `${values[i]}, `;
            }
        }
        if (tooltip.length > 2) {
            return tooltip.substring(0, tooltip.length - 2);
        }
        return tooltip;
    }

    static mapParameterWithTransform(a) {
        const element = a.data("kendoMultiSelectWithAutoTransform").input.val();
        return { text: element };
    }

    itemChangeClientSide = () => {
        if (!this.isUpdating) {
            if (this.value().length > this.countUntilTransform) {
                this.convertToSingleItem();
            } else {
                this.convertToTagList();
                if (!$(".isReadOnly").length) {
                    const controlGroupWidth = this.wrapper.find(".k-multiselect-wrap").width() - 50;
                    this.wrapper.find("li").each((index, element) => {
                        const item = $(element);
                        if (item.outerWidth() >= controlGroupWidth) {
                            item.find(".dropDownAvatarBackgroundText").addClass("limitWidth");
                        }
                    });
                }
            }
        }
    }

    convertToSingleItem = () => {
        if (this.options.tagMode !== "single") {
            this.isUpdating = true;

            const values = this.value();

            this.options.tagMode = "single";
            this.options.clearButton = false;
            (<any> this)._tagTemplate(); 

            const total = this.dataSource.total();
            const tagList = this.tagList;

            if (!(<any> this)._maxTotal || (<any> this)._maxTotal < total) { 
                (<any> this)._maxTotal = total; 
            }

            tagList.html("");

            if (values.length) {
                tagList.append((<any> this).tagTemplate({ 
                    values,
                    dataItems: this.dataItems(),
                    maxTotal: (<any> this)._maxTotal, 
                    currentTotal: total
                }));
            }
            this.isUpdating = false;
        }
    }

    convertToTagList = () => {
        if (this.options.tagMode !== "multiple") {
            this.isUpdating = true;

            const tagList = this.tagList;

            this.options.tagMode = "multiple";
            this.options.clearButton = true;
            (<any> this)._tagTemplate(); 

            tagList.html("");
            this.dataItems().forEach((item) => {
                tagList.append((<any> this).tagTemplate(item)); 
            });

            this.isUpdating = false;
        }
    }

    selectItems = (value) => {
        const oldArray = [];
        for (let i = 0; i < value.length; i++) {
            const dataItem = this.dataSource.get(value[i]);
            if (!dataItem) {
                oldArray.push(value[i]);
            }
        }
        this.value(oldArray);
        let def = $.Deferred().resolve().promise();
        for (let i = 0; i < value.length; i++) {
            const dataItem = this.dataSource.get(value[i]);
            if (dataItem) {
                def = def.then((<any>(this)).listView.select(this.list.find(`[data-uid='${dataItem.uid}']`))).then((<any>(this)).listView._selectedDataItems.push(dataItem)); 
            }
        }
    }
}

// Create an alias of the prototype (required by kendo.ui.plugin)
MultiSelectWithAutoTransform.fn = MultiSelectWithAutoTransform.prototype;
// Deep clone the widget default options
MultiSelectWithAutoTransform.fn.options = $.extend(true, {}, kendo.ui.MultiSelect.fn.options);
// Specify the name of your Kendo UI widget. Used to create the corresponding jQuery plugin.
MultiSelectWithAutoTransform.fn.options.name = "MultiSelectWithAutoTransform";
// Create a jQuery plugin.
kendo.ui.plugin(MultiSelectWithAutoTransform);
